const stats = [
  {
    value: "10+",
    label: "Years of Design Experience",
    labelZh: "十年以上设计经验",
    sub: "Trusted by industry leaders",
    subZh: "深受行业领袖信赖"
  },
  {
    value: "100+",
    label: "Projects Completed",
    labelZh: "完成项目",
    sub: "Spanning residential, cultural & commercial",
    subZh: "涵盖住宅、文化与商业领域"
  },
  {
    value: "10+",
    label: "Industry Awards",
    labelZh: "行业奖项",
    sub: "Recognized by domestic & international authorities",
    subZh: "国内外权威机构认可"
  },
];

const teamMembers = [
  {
    role: "Creative Director",
    roleZh: "创意设计总监",
    members: [
      {
        title: "Creative Director",
        titleZh: "创意设计总监",
      },
    ],
  },
  {
    role: "Project Manager",
    roleZh: "项目经理",
    members: [
      {
        title: "Project Manager",
        titleZh: "项目经理",
      },
    ],
  },
  {
    role: "Designer",
    roleZh: "设计师",
    members: [
      {
        title: "Designer",
        titleZh: "设计师",
      },
    ],
  },
];

export default function AboutUsSection() {
  return (
    <section id="about" className="py-28 bg-white">
      <div className="max-w-screen-xl mx-auto px-8 lg:px-20">
        {/* Main Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
          {/* Left Text */}
          <div>
            <p className="text-xs tracking-[0.35em] text-stone-400 mb-4"
               style={{ fontFamily: "'DM Sans', sans-serif" }}>
              WHO WE ARE · 关于我们
            </p>
            <h2
              className="text-5xl lg:text-6xl font-black text-stone-900 leading-tight mb-4"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              We design spaces<br />
              <em className="not-italic text-amber-700">that endure,</em><br />
              that inspire.
            </h2>
            <p className="text-base text-stone-400 mb-8 font-light tracking-wide"
               style={{ fontFamily: "'Noto Serif SC', serif" }}>
              我们设计经久不衰、令人心动的空间
            </p>
            <p className="text-sm text-stone-500 leading-relaxed mb-2"
               style={{ fontFamily: "'DM Sans', sans-serif" }}>
              成立于 2022 年的我们，是一家专注于建筑与空间设计的国际工作室。多年来，我们以诗意的设计语言和严谨的工程态度，为各类城市与自然场景中的人居、商业、文化空间赋予独特的精神气质。我们不限于纯概念设计，我们也精耕设计管理。
            </p>
            <p className="text-xs text-stone-400 leading-relaxed mb-5 italic"
               style={{ fontFamily: "'DM Sans', sans-serif" }}>
              Founded in 2022, we are an international studio dedicated to architecture and spatial design. Over the years, we have brought a poetic design language and rigorous engineering approach to residential, commercial, and cultural spaces across urban and natural settings — extending beyond pure concept design into the discipline of design management.
            </p>
            <p className="text-sm text-stone-500 leading-relaxed mb-2"
               style={{ fontFamily: "'DM Sans', sans-serif" }}>
              我们相信，真正优秀的设计不仅仅是形式的表达，更是对人类生活方式最深刻的回应——在材料、光线与结构的交汇处，空间开始诉说属于它自己的故事。
            </p>
            <p className="text-xs text-stone-400 leading-relaxed mb-10 italic"
               style={{ fontFamily: "'DM Sans', sans-serif" }}>
              We believe that truly great design is not merely an expression of form, but the most profound response to the human way of life — at the intersection of material, light, and structure, space begins to tell its own story.
            </p>
            <button
              className="inline-flex items-center gap-3 bg-stone-900 text-white px-10 py-4 text-xs tracking-[0.2em] hover:bg-amber-700 transition-colors duration-300 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              LEARN MORE · 了解更多
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </div>
            </button>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="w-full h-[520px] overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/d6183e56381ec21c6ce3b91972a7def1.jpg"
                alt="Our Studio"
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating Tag */}
            <div className="absolute -bottom-6 -left-6 bg-stone-900 text-white p-6 w-44">
              <p className="text-3xl font-black mb-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>10+</p>
              <p className="text-xs text-stone-400 tracking-widest leading-tight"
                 style={{ fontFamily: "'DM Sans', sans-serif" }}>
                年卓越设计<br />
                <span className="text-stone-500">YEARS OF EXCELLENCE</span>
              </p>
            </div>
          </div>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-t border-stone-200 pt-16">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              className={`pr-12 ${idx !== 0 ? "pl-12 border-l border-stone-200" : ""}`}
            >
              <p
                className="text-5xl font-black text-stone-900 mb-2"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {stat.value}
              </p>
              <p className="text-sm font-medium text-stone-800 mb-0.5"
                 style={{ fontFamily: "'DM Sans', sans-serif" }}>
                {stat.label}
              </p>
              <p className="text-xs font-medium text-stone-500 mb-1"
                 style={{ fontFamily: "'DM Sans', sans-serif" }}>
                {stat.labelZh}
              </p>
              <p className="text-xs text-stone-400"
                 style={{ fontFamily: "'DM Sans', sans-serif" }}>
                {stat.sub}
              </p>
              <p className="text-xs text-stone-300 italic"
                 style={{ fontFamily: "'DM Sans', sans-serif" }}>
                {stat.subZh}
              </p>
            </div>
          ))}
        </div>

        {/* Design Philosophy */}
        <div className="mt-24 border-t border-stone-200 pt-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div>
              <p className="text-xs tracking-[0.35em] text-stone-400 mb-4"
                 style={{ fontFamily: "'DM Sans', sans-serif" }}>
                OUR PHILOSOPHY · 设计理念
              </p>
              <h2
                className="text-4xl lg:text-5xl font-black text-stone-900 leading-tight mb-4"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                Design that<br />
                <em className="not-italic text-amber-700">tells a story.</em>
              </h2>
              <p className="text-base text-stone-400 mb-8 font-light tracking-wide"
                 style={{ fontFamily: "'Noto Serif SC', serif" }}>
                设计，讲述一段故事
              </p>
              <p className="text-sm text-stone-500 leading-relaxed mb-3"
                 style={{ fontFamily: "'DM Sans', sans-serif" }}>
                WEXTIN design studio(YEAHSTUDIO)（隐也建筑设计咨询（上海）有限公司）深信，每一个空间都承载着独特的叙事潜力。我们的设计方法以深度研究为基础，从品牌基因、使用者行为与场地文脉出发，将抽象的概念转化为可感知的空间体验。无论是上海的零售设计项目，还是跨城市的品牌空间标准化落地，我们始终以严谨的工程态度与诗意的设计语言，确保每一个细节都经得起时间的检验。
              </p>
              <p className="text-xs text-stone-400 leading-relaxed italic mb-6"
                 style={{ fontFamily: "'DM Sans', sans-serif" }}>
                YEAHSTUDIO believes every space carries unique narrative potential. Our design methodology is grounded in deep research — drawing from brand DNA, user behavior, and site context to transform abstract concepts into tangible spatial experiences. Whether retail design projects in Shanghai or cross-city brand space standardization, we apply rigorous engineering discipline and poetic design language to ensure every detail stands the test of time.
              </p>
            </div>
            <div className="space-y-6">
              {[
                {
                  icon: "ri-focus-3-line",
                  title: "以人为本 / Human",
                  desc: "每一个设计决策都以使用者的真实体验为核心出发点，通过对行为动线、感官体验与情感共鸣的深度研究，创造真正服务于人的空间。",
                  descEn: "Every design decision is rooted in the authentic experience of the user. Through deep research into behavioral flow, sensory perception, and emotional resonance, we create spaces that genuinely serve people.",
                },
                {
                  icon: "ri-lightbulb-line",
                  title: "叙事性设计 / Narrative Design",
                  desc: "我们将品牌故事、文化背景与空间语言融为一体，让每一个商业设计、零售空间或住宅项目都成为一段独特的叙事旅程。",
                  descEn: "We weave brand stories, cultural context, and spatial language into a unified whole — transforming every commercial design, retail space, or residential project into a distinctive narrative journey.",
                },
                {
                  icon: "ri-sparkling-line",
                  title: "精致克制 / Sophisticated",
                  desc: "Sophisticated 并非繁复，而是一种经过深思熟虑后的克制——在材质的选择、比例的拿捏与细节的取舍之间，找到那个恰到好处的平衡点。真正的精致，是让人感受到用心，却看不见刻意。",
                  descEn: "Sophisticated is not complexity — it is restraint born of deep deliberation. In the choice of material, the calibration of proportion, and the editing of detail, we seek the point of perfect balance. True sophistication is felt in the care, never seen in the effort.",
                },
                {
                  icon: "ri-tools-line",
                  title: "精工落地 / Precision Execution",
                  desc: "从概念方案到施工完成，我们的设计管理团队全程把控品质，确保设计意图在每一个执行环节中得到忠实呈现，为品牌与业主创造持久价值。",
                  descEn: "From concept to construction completion, our design management team oversees quality at every stage — ensuring design intent is faithfully realized in every phase of execution, and creating lasting value for brands and clients alike.",
                },
              ].map((item) => (
                <div key={item.title} className="flex gap-5 items-start">
                  <div className="w-10 h-10 flex items-center justify-center border border-stone-200 shrink-0">
                    <i className={`${item.icon} text-stone-500`} />
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-stone-800 mb-1"
                        style={{ fontFamily: "'DM Sans', sans-serif" }}>
                      {item.title}
                    </h3>
                    <p className="text-xs text-stone-500 leading-relaxed mb-1"
                       style={{ fontFamily: "'DM Sans', sans-serif" }}>
                      {item.desc}
                    </p>
                    <p className="text-xs text-stone-400 leading-relaxed italic"
                       style={{ fontFamily: "'DM Sans', sans-serif" }}>
                      {item.descEn}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Team Section */}
        <div className="mt-28 border-t border-stone-200 pt-20">
          <div className="mb-16">
            <p className="text-xs tracking-[0.35em] text-stone-400 mb-4"
               style={{ fontFamily: "'DM Sans', sans-serif" }}>
              OUR TEAM · 团队成员
            </p>
            <h2
              className="text-4xl lg:text-5xl font-black text-stone-900 leading-tight mb-4"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              The people behind<br />
              <em className="not-italic text-amber-700">every great space.</em>
            </h2>
            <p className="text-base text-stone-400 font-light tracking-wide"
               style={{ fontFamily: "'Noto Serif SC', serif" }}>
              每一个卓越空间背后的人
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {teamMembers.map((group, gIdx) => {
              const member = group.members[0];
              return (
                <div key={gIdx} className="flex flex-col">
                  {/* Photo Placeholder */}
                  <div className="w-full h-80 overflow-hidden mb-6 bg-stone-100 flex items-center justify-center">
                    <div className="flex flex-col items-center gap-3 text-stone-300">
                      <div className="w-12 h-12 flex items-center justify-center">
                        <i className="ri-user-3-line text-4xl" />
                      </div>
                      <span className="text-xs tracking-widest" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                        PHOTO
                      </span>
                    </div>
                  </div>

                  {/* Info */}
                  <div>
                    <div className="h-5 w-32 bg-stone-100 rounded mb-3" />
                    <p
                      className="text-xs tracking-widest text-amber-700 mb-1.5 uppercase"
                      style={{ fontFamily: "'DM Sans', sans-serif" }}
                    >
                      {member.title}
                    </p>
                    <p
                      className="text-xs text-stone-400 mb-4"
                      style={{ fontFamily: "'DM Sans', sans-serif" }}
                    >
                      {member.titleZh}
                    </p>
                    <div className="flex items-center gap-3 mb-4">
                      <span className="text-xs tracking-[0.25em] text-stone-300 uppercase"
                        style={{ fontFamily: "'DM Sans', sans-serif" }}>
                        {group.role}
                      </span>
                      <span className="text-stone-200">·</span>
                      <span className="text-xs text-stone-300"
                        style={{ fontFamily: "'DM Sans', sans-serif" }}>
                        {group.roleZh}
                      </span>
                    </div>
                    <div className="space-y-1.5">
                      <div className="h-3 w-full bg-stone-100 rounded" />
                      <div className="h-3 w-5/6 bg-stone-100 rounded" />
                      <div className="h-3 w-4/6 bg-stone-100 rounded" />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
